module.exports = __webpack_public_path__ + "img/route.3f0974f4.png";